import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateBranch({ username, onGroupID, onClose, getGroups }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [objectList, setObjectList] = useState([]);
    const [currentObjectGroups, setCurrentObjectGroups] = useState([]);
    const [checkedObjects, setCheckedObjects] = useState([]);
    const [addedObject, setAddedObject] = useState([]);
    const [removedObject, setRemovedObject] = useState([]);
    const [errors, setErrors] = useState({});

    let user2;
    try {
        user2 = JSON.parse(username);
    } catch (e) {
        user2 = username;
    }

    const [formData, setFormData] = useState({
        name: '',
        comment: '',
        user_transaction: user2,
        objects_add: '',
        objects_del: '',
        est_id: '',
        id: ''
    });

    useEffect(() => {
        const getGroupsBK = async () => {
            try {
                const response = await axios.get(`${server_backend}/groups/select?id=${onGroupID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setCurrentObjectGroups(data.objects);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID,
                        id: onGroupID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getGroupsBK();
    }, [onGroupID, username]);

    useEffect(() => {
        const getObject = async () => {
            try {
                const response = await axios.get(`${server_backend}/objects/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setObjectList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getObject();

    }, []);

    useEffect(() => {

        if (currentObjectGroups && objectList.length > 0) {

            const initialCheckedGroups = objectList.map(object => ({
                ...object,
                isChecked: currentObjectGroups.some(userObject => userObject.obj_ID === object.obj_ID)
            }));
            setCheckedObjects(initialCheckedGroups);
        } else {

            const initialCheckedGroups = objectList.map(object => ({
                ...object,
                isChecked: false
            }));
            setCheckedObjects(initialCheckedGroups);

        }

    }, [objectList, currentObjectGroups]);

    const handleCheckboxChange = (obj_ID) => {
        setCheckedObjects(prevState =>
            prevState.map(object => {
                if (object.obj_ID === obj_ID) {
                    const isChecked = !object.isChecked;

                    if (isChecked) {
                        if (removedObject.includes(obj_ID)) {
                            setRemovedObject(removedObject.filter(id => id !== obj_ID));
                        } else {
                            setAddedObject([...addedObject, obj_ID]);
                        }
                    } else {
                        if (addedObject.includes(obj_ID)) {
                            setAddedObject(addedObject.filter(id => id !== obj_ID));
                        } else {
                            setRemovedObject([...removedObject, obj_ID]);
                        }
                    }

                    return { ...object, isChecked };
                }
                return object;
            })
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {

        if (!validateFormData()) {
            return;
        }

        e.preventDefault();


        // Convert added and removed objects to comma-separated strings
        const objects_add = addedObject.join(',');
        const objects_del = removedObject.join(',');

        const updatedFormData = {
            ...formData,
            objects_add,
            objects_del
        };

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/groups/update`, updatedFormData, headers);
                    setLoading(true);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });
                        getGroups()
                        onClose();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'There is already a group with the same name, please try with another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }

            }
        });
    };

    const validateFormData = () => {
        const { name } = formData;
        const newErrors = {};

        if (name.length < 3) {
            newErrors.name = 'Name is required';
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className='card'>
            <div className="card-header align-items-center d-flex">
                <div className="col-md-12">
                    <div className="text-end">
                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Alert',
                                text: "Are you sure you want to discard these changes?",
                                showCancelButton: true,
                                confirmButtonText: 'Accept',
                                cancelButtonText: "Cancel"
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    onClose();
                                }
                            }
                            )
                        }
                        }>Discard Change</Link>
                        <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                            {loading ? "Loading..." : "Update"}
                        </Link>
                    </div>
                </div>
            </div>

            <div className="modal-body">
                <div className="tab-pane fade show active" id="pills-bill-info" role="tabpanel" aria-labelledby="pills-bill-info-tab">
                    <div className="live-preview">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            name="name"
                                            value={onGroupID}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <span className="text-danger" style={{ fontSize: "20px", marginLeft: "5px" }}>*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}

                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"

                                            id="comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">User Transaction</label>
                                        <input
                                            type="text"
                                            className="form-control"

                                            id="user_transaction"
                                            value={user2}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Status</label>
                                        <select
                                            className="form-select"
                                            aria-label=".form-select-sm example"
                                            name="est_id"
                                            value={formData.est_id}
                                            onChange={handleChange}
                                        >
                                            {formData.est_id === 1 ? (
                                                <>
                                                    <option value="1">Activated</option>
                                                    <option value="2">Disabled</option>
                                                </>
                                            ) : (
                                                <>
                                                    <option value="2">Disabled</option>
                                                    <option value="1">Activated</option>
                                                </>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <h4 className='p-4'>Objects</h4>
                                <div className="col-md-12 mb-3 p-4">
                                    <div className="row">
                                        {checkedObjects.map(object => (
                                            <div className="col-md-3 form-check mb-3" key={object.obj_ID}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`group-${object.obj_ID}`}
                                                    checked={object.isChecked}
                                                    onChange={() => handleCheckboxChange(object.obj_ID)}
                                                />
                                                <label className="form-check-label" htmlFor={`group-${object.obj_ID}`}>
                                                    {object.name}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <h4 className='p-4'>Other Information</h4>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="user_transaction"
                                            value={vAdminformat.FormatDate(dateCreated)}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">User Created</label>
                                        <input
                                            type="text"
                                            className="form-control"

                                            id="user_transaction"
                                            value={userCreated}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                        <input
                                            type="text"
                                            className="form-control"

                                            id="user_transaction"
                                            value={dateModify && vAdminformat.FormatDate(dateModify)}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                        <input
                                            type="text"
                                            className="form-control"

                                            id="user_transaction"
                                            value={userModify}
                                            name="user_transaction"
                                            disabled
                                        />
                                    </div>
                                </div>


                                <div className="col-md-12">

                                    <div className="text-end">
                                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Alert',
                                                text: "Are you sure you want to discard these changes?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Accept',
                                                cancelButtonText: "Cancel"
                                            }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                    onClose();
                                                }
                                            }
                                            )
                                        }
                                        }>Discard Change</Link>
                                        <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                            {loading ? "Loading..." : "Update"}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    {/* end preview */}
                </div>
                {/* end tab content */}
            </div>
        </div>
    );
}

export default UpdateBranch;
